import styled from 'styled-components';
import { TextLink } from '../PublicReportCard/PublicReportCard.styles';

export const BackTextLink = styled(TextLink)`
  display: flex;
  align-items: center;
  margin: 0;

  & svg {
    transform: scale(1.7);
    margin-right: 3px;
  }

  @media screen and (min-width: 0px) and (max-width: 480px) {
    margin-top: 25px;
  }
`;

export const BackLinkContainer = styled.div`
  display: flex;
  align-items: flex-start;
  width: 85%;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: none;
  }
`;

export const EvidenceList = styled.div`
  width: 85%;
  height: 60%;
  overflow: auto;
  overflow-wrap: anywhere;
  margin-top: 15px;
  padding-bottom: 15px;
  padding-right: 5px;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    height: 100%;
    margin: 20px 0;
    width: 340px;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
  }
`;

export const Evidence = styled.div<{ firstEvidence: boolean }>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: ${(props) => (props.firstEvidence ? '-15px' : '0')};
  height: min-content;
`;

export const EvidenceIcon = styled.div<{ firstEvidence: boolean }>`
  display: flex;
  flex-direction: column;
  margin-right: 15px;
  margin-left: 8px;
  justify-content: ${(props) =>
    props.firstEvidence ? 'flex-end' : 'flex-start'};
  margin-top: ${(props) => (props.firstEvidence ? '25px' : '0')};

  & img {
    height: 25px;
  }
`;

export const VerticalLine = styled.div`
  border-left: 2px solid ${(props) => props.theme.newPalette.neutral.N900};
  height: 60%;
  margin-left: 11px;
`;

export const EvidenceCard = styled.div<{ noPadding?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0px 0px 11px -1px rgba(150, 150, 150, 0.3);
  color: ${(props) => props.theme.newPalette.neutral.N800};
  margin-top: 20px;
  padding: ${(props) => (props.noPadding ? '0 20px 0 0' : '20px')};
  width: 100%;
  line-height: 1.5;
  font-size: 12px;
  font-weight: 100;
  height: min-content;

  & h2 {
    ${(props) => props.theme.newTypography.textStyleBodySemibold}
    margin-top: 0px;
  }

  & p {
    ${(props) => props.theme.newTypography.textStyleBody}
    margin: 0;
    white-space: pre-line;
  }

  & i {
    color: ${(props) => props.theme.newPalette.neutral.N600};
  }
`;
